import {
  AppRouteParams,
  PathParamDef,
  RouteDef,
  RouteWithParams,
} from 'common/src/modules/routing/routing.types';
import {RootState} from 'common/src/redux/store';

function defaultRouteFormatter({
  routeDef,
  route,
}: {
  routeDef: RouteDef;
  route: RouteWithParams;
  getState: () => RootState;
}): string {
  let result = '';
  result += _formatPathParams(routeDef.pathParams, route.pathParamValues);

  return result;
}

function _formatPathParams(pathParamDefs: PathParamDef[], pathParamValues: AppRouteParams): string {
  if (pathParamDefs.length === 0) {
    return '';
  }

  let result = '';

  for (const pathParamDef of pathParamDefs) {
    const value = pathParamValues[pathParamDef.key];

    const valueToDisplay = value ?? pathParamDef.defaultValue;

    if (valueToDisplay) {
      result += `\n- ${pathParamDef.displayName}: ${valueToDisplay}`;
    }
  }

  return result;
}

export default defaultRouteFormatter;
